<template>
  <div>
    <div class="provider-info">
      <img src="../logos/yahoo-logo.svg">
    </div>
    <p>
      If you use Yahoo! Small Business as your email provider,
      you'll need to create an auto-forwarding rule
      from <strong>{{forwardingFromAddress}}</strong> to:
    </p>
    <clipboard-text :text="incomingEmailAddress" class="incoming-email-address" />
    <p><br></p>
    <p>
      Follow <strong><a href="https://help.yahoo.com/kb/new-mail-for-desktop/enable-automatic-email-forwarding-yahoo-mail-sln29133.html" target="_blank" class="just-a-link">these instructions</a></strong>
      to enable automatic email forwarding in Yahoo.
    </p>
    <p><br></p>
    <p>
      When you've completed the steps provided by Yahoo, click below to test that everything is working as expected.
    </p>
    <p><br></p>
    <dd-button
      :color="ColorAssistant.MailboxColor"
      size="large"
      full-width
      @click="$emit('completion-clicked')"
    >I've set up the auto-forwarding rule. Verify auto-forwarding is working!</dd-button>
  </div>
</template>
<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default defineComponent({
  name: 'MailboxVerificationInstructionsYahoo',
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  emits: ['completion-clicked'],
  data() {
    return {
      ColorAssistant,
      curSelection: '',
    }
  },
})
</script>

<style lang="scss">
// Shared from root mailbox-verification-auto-forwarding.vue
</style>
